import * as TradingView from '#/vendor/charting_library';

import { UDFCompatibleDatafeed } from '#/features/tradingview/datafeeds/udf/udf-compatible-datafeed';

import { LOADING_SCREEN_STYLES, STUDIES_STYLES, MAIN_STYLES } from './styling';

// WIP:
//  our TradingView API may experience degraded performance on large volumes of data,
//  so we can not yet apply something like 5d TIMEFRAME as it has large trading volume and may cause the chart to load slowly
//  and even error out as our TradingView API can time out with 504
const TIMEFRAME = '12h';
const INTERVAL = '5';

const getBaseOptions = (): Omit<
  TradingView.ChartingLibraryWidgetOptions,
  'container' | 'symbol'
> => ({
  autosize: true,
  /**
   * For available disabled_features, enabled_features:
   * @see https://charting-library.tradingview-widget.com/featuresets.html
   * @see https://github.com/tradeparadigm/tradingview_charting_library/wiki/Featuresets
   */
  disabled_features: [
    'left_toolbar',
    'header_symbol_search',
    'header_compare',
    'header_screenshot',
    'header_undo_redo',
    'header_indicators',
    'header_settings',
    'timeframes_toolbar',
  ],
  timeframe: TIMEFRAME,
  favorites: {
    intervals: [
      '1',
      '5',
      '30',
      '60',
      '120',
      '1D',
    ] as TradingView.ResolutionString[],
  },
  interval: INTERVAL as TradingView.ChartingLibraryWidgetOptions['interval'],
  timezone: 'exchange',
  datafeed: new UDFCompatibleDatafeed(`${API_URL}/tradingview`, 10 * 1000),
  theme: 'Dark',
  locale: 'en',
  library_path: `${FE_DOMAIN}/vendor/charting_library/`,
  client_id: 'paradex',
  fullscreen: false,
  custom_css_url: '/vendor/tradingview-style-overrides.css',
  /**
   * Customize font family for the chart.
   * To customize fonts outside of the chart see `custom_css_url`.
   * @see https://www.tradingview.com/charting-library-docs/latest/api/interfaces/Charting_Library.ChartingLibraryWidgetOptions#custom_font_family
   */
  custom_font_family: "'Roboto Mono', monospace",
  /**
   * Override styles for chart
   * @see https://github.com/tradeparadigm/tradingview_charting_library/wiki/Overrides
   */
  overrides: MAIN_STYLES,
  /**
   * Override styles for indicators
   * @see https://github.com/tradeparadigm/tradingview_charting_library/wiki/Studies-Overrides
   */
  studies_overrides: STUDIES_STYLES,
  loading_screen: LOADING_SCREEN_STYLES,
});

export type TradingViewWidget = TradingView.IChartingLibraryWidget;

export function createWidget(
  options: Pick<
    TradingView.ChartingLibraryWidgetOptions,
    'container' | 'symbol'
  >,
): TradingViewWidget {
  // eslint-disable-next-line new-cap
  const widget = new TradingView.widget({ ...getBaseOptions(), ...options });
  widget.onChartReady(() => {
    // Declaring overrides in the widget options do
    // not work as expected, hence re-applying here.
    widget.applyOverrides(MAIN_STYLES);
  });
  return widget;
}
